import request from '@/utils/request'
//  获取回放列表
export const zbRooms = (data) => request('/tools/zb-rooms', data);